import { Navbar, Main, Product } from "../components";

function Home() {
  return (
    <>
      <Navbar />
      <Main />
      <Product />
    </>
  );
}

export default Home;
